import { useEffect, useState } from "react";
import MailLockIcon from "../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg";
import { Link, useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import CallAPI from "../../services/apiCalls";

const DetailsOrgEmails = ({ detailsEmail, emailRefresh }) => {
  const navigate = useNavigate();
  const { userToken, SetSharedObject, sharedObject, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userSession: state.userSession,
    }));
  const [collapse, SetCollapse] = useState(false);
  const [flag, setFlag] = useState(false);
  const [answers, setAnswers] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [emlShareObj, setEmlShareObj] = useState([]);
  const [emlForwarding, setEmlForwarding] = useState([]);
  const [msg, setMsg] = useState(
    "Email purpose has been updated successfully."
  );
  const [msgModal, setMsgModal] = useState(
    "Unchecking this box will remove all users access to this email box."
  );
  const [errMsg, setErrMsg] = useState(
    "Email purpose cannot be updated at this time. Please contact customer support for further assistance."
  );
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [xdrAccessOrg, setXdrAccessOrg] = useState(false);

  useEffect(() => {
    setSubmitFlag(false);
    if (flag) navigate(flag, { replace: true });
    const temp = [];
    let obj = sharedObject.emailsSharing;
    if (obj && obj.length > 0) {
      for (const el of obj) {
        el.show = true;
        temp.push(el);
      }
    }
    setEmlShareObj(temp);
    if (
      Object.keys(detailsEmail).length > 0 &&
      detailsEmail.constructor === Object
    ) {
      DetailEmailFunc(detailsEmail);
      setXdrAccessOrg(sharedObject.orgActionObj?.xdrEnabled);
      //getXDRData(detailsEmail.organizationId);
      if (detailsEmail.emailForwording) {
        setEmlForwarding(detailsEmail.emailForwording);
      }
    }
  }, [flag, navigate, detailsEmail, sharedObject.emailsSharing]);

  const DetailEmailFunc = async (detailsEmail) => {
    await setAnswers({
      ...answers,
      Purpose:
        detailsEmail.emailType === "userEmails" ||
        detailsEmail.emailType === "orgEmails"
          ? detailsEmail.emailPurposeId
          : detailsEmail.directEmailPurposeId,
      KeepMdn:
        detailsEmail.emailType === "orgEmails" ||
        detailsEmail.emailType === "userEmails"
          ? detailsEmail.keepMDN
            ? 1
            : 0
          : detailsEmail.isKeepMDN
          ? 1
          : 0,
      SharingAllowed: detailsEmail.sharingAllowed,
      NoReply: detailsEmail.noReply,
      DirectTrustServiceDescriptionCode:
        detailsEmail.directTrustServiceDescriptionCode,
    });
  };
  const UnAssignEmail = async (id, userId, flag) => {
    var uId = userId ? userId : userSession.vendor_id;
    if (!flag) setSubmitFlag(true);
    setProcessing(true);
    let call =
      "/emails/RemoveSharedEmail?directEmailId=" +
      parseInt(id) +
      "&userId=" +
      uId;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      if (flag) {
        setEmlShareObj([]);
      } else {
        for (const elx of emlShareObj) {
          if (elx.userId === uId) {
            elx.show = false;
          }
          temp.push(elx);
        }
        setEmlShareObj(temp);
        setMsg("User have been unassigned successfully.");
      }
      if (!flag) setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      setErrMsg(
        "Email sharing cannot be removed at this time. Please contact customer support for further assistance."
      );
      setSuccessFlag(false);
    }
    setProcessing(false);
  };
  const UpdateEmail = async () => {
    setSubmitFlag(true);
    setProcessing(true);
    let mdn = answers.KeepMdn === 1 ? true : false;
    let call =
      "/emails/UpdateDirectEmail?directEmailId=" +
      parseInt(detailsEmail.directEmailId) +
      "&purposeId=" +
      answers.Purpose +
      "&isKeepMDN=" +
      mdn +
      "&noReply=" +
      answers.NoReply +
      "&directTrustServiceDescriptionCode=" +
      answers.DirectTrustServiceDescriptionCode +
      "&type=" +
      detailsEmail.userEmailTypeString +
      "&email=" +
      detailsEmail.directEmailAddress;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let uId = detailsEmail.organizationId;
      let detEmails = {
        ...detailsEmail,
        Id: uId,
        Flag: detailsEmail.emailType,
      };
      emailRefresh(detEmails);
      setMsg("Email has been updated successfully.");
      setSuccessFlag(true);
      detailsEmail.directEmailPurposeId = answers.Purpose;
      detailsEmail.isKeepMDN = mdn;
    } else if (res.status === "SERVERERROR") {
      setMsg(
        "Email cannot be updated at this time. Please contact customer support for further assistance."
      );
      setSuccessFlag(false);
    }
    setProcessing(false);
  };
  const ConfirmUnsharing = async () => {
    let call =
      "/emails/UpdateOrgSharingEmail?directEmailId=" +
      parseInt(detailsEmail.directEmailId) +
      "&organizationId=" +
      detailsEmail.organizationId +
      "&sharingAllowed=" +
      answers.SharingAllowed;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let tmp = [];
      for (let e of sharedObject.emailListObj) {
        if (e.directEmailId === detailsEmail.directEmailId)
          e.sharingAllowed = answers.SharingAllowed;
        tmp.push(e);
      }
      SetSharedObject("emailListObj", tmp);
      if (!answers.SharingAllowed)
        for (let el of emlShareObj) {
          await UnAssignEmail(el.id, el.userId, true);
        }
      CloseEmailSharingModal();
    } else if (res.status === "SERVERERROR") {
      CloseEmailSharingModal();
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    $(`#${modalId}`).modal('hide');
    $(".modal").modal('hide'); 
};

const CloseEmailDetailModal = () => closeModal('detailsEmailOrgModal');
const CloseEmailSharingModal = () => closeModal('ConfirmUnsharingModal');

 // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#detailsEmailOrgModal").hasClass("show")) CloseEmailDetailModal();
        if ($("#ConfirmUnsharingModal").hasClass("show")) CloseEmailSharingModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="DetailsOrgEmails">
      <div
        className="modal fade"
        id="detailsEmailOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="detailsEmailOrgModalTitle"
        aria-describedby="detailsEmailOrgModalDesc"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="detailsEmailOrgModalTitle"
                tabIndex={0}
              >
                Details
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={CloseEmailDetailModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form aria-label="Email Details Form">
              <div className="modal-body">
              <p id="detailsEmailOrgModalDesc" className="sr-only">
                  View and update email details including purpose, MDN settings, and sharing options.
                </p>
                <div className="modal-content-body container">
                  <div className="details-header spacer-margin3">
                    <img src={MailLockIcon} alt="" aria-hidden="true" />
                    <div className="details-name" aria-label={`Email: ${detailsEmail.directEmailAddress || "unknown"}`}>
                      {detailsEmail.directEmailAddress}
                    </div>
                  </div>
                  <div className="field-wrapper">
                    {detailsEmail.emailType ? (
                      <>
                        <dl className="detail-list sp-mx7">
                        <dt>Email Type:</dt>
                        <dd>{detailsEmail.emailType}</dd>
                      </dl>
                      </>
                       ) : null}

                    {detailsEmail.emailType === "User" ||
                    detailsEmail.emailType === "userEmails" ? (
                      <>
                        <d1 className="detail-list">
                            <dt>Username:</dt>
                            <dd>{detailsEmail?.userName?.split("|")[0]}</dd>
                        </d1>
                       <d1 className="detail-list">
                        <dt>Name:</dt>
                        <dd>
                            <Link
                                onClick={(el) => {
                                let o = {
                                    UserName: detailsEmail.userName.split("|")[0],
                                    Name: detailsEmail.name,
                                    OrgName:
                                    sharedObject?.orgDetails?.organizationName,
                                    Navigate: "detailUser",
                                    Flag: "orgEmails",
                                    //UserEmail: detailsEmail.directEmailAddress,
                                };
                                SetSharedObject("UserIdEmail", o);
                                closeModal();
                                setFlag("/users");
                                }}
                            >
                                {detailsEmail.name}
                            </Link>
                         </dd>
                        </d1>
                       </>
                    ) : (
                      <dl className="dtail-list sp-mx7">
                        <dt>Organization:</dt>
                        <dd>
                          <Link
                            onClick={(el) => {
                              let o = {
                                OrganizationId: detailsEmail?.organizationId,
                                CustomerId: detailsEmail?.CustomerId,
                                id: sharedObject?.orgDetails?.vendorId,
                                Id: detailsEmail?.organizationId,
                                Name: detailsEmail?.name,
                                OrgName:
                                  sharedObject?.orgDetails?.organizationName,
                                Navigate: "orgEmails",
                                Flag: "orgEmails",
                              };
                              SetSharedObject("UserIdEmail", o);
                              closeModal();
                              setFlag("/organizations");
                            }}
                          >
                            {detailsEmail.name}
                          </Link>
                        </dd>
                      </dl>
                    )}
                    <dl className="detail-list sp-mx7">
                        <dt>Created Date:</dt>
                        <dd>
                          {new Date(detailsEmail.dateCreated).toLocaleString(
                            "en-US",
                            { hour12: false }
                          )}
                        </dd>
                    </dl>
                    <dl className="detail-list">
                        <dt>Created By:</dt>
                        <dd>{detailsEmail.createdBy?.split("|")[0]}</dd>
                    </dl>
                  </div>

                  <div aria-label="XDR Configuration">
                    <div className="field-wrapper">
                      {xdrAccessOrg ? (
                        <>
                        <dl className="sp-mx7">
                          <dt>Inbound XDR:</dt>
                          <dd>
                            {sharedObject?.orgActionObj?.xdrEnabled
                              ? "Enabled"
                              : "Disabled"}
                          </dd>
                        </dl>
                        <div className="sub-catg">
                            <dl className="sp-mx7">
                                <dt>Config Name:</dt>
                                <dd>{sharedObject?.xdrSettiingObj?.endpointName}</dd>
                            </dl>
                            <dl className="sp-mx7">
                                <dt>Endpoint URL:</dt>
                                <dd className="word-set">
                                {sharedObject?.xdrSettiingObj?.endpointAddress}
                                </dd>
                            </dl>
                            <dl className="sp-mx7">
                                <dt>Deliver MDN:</dt>
                                <dd>{sharedObject?.xdrSettiingObj?.mdnForward
                                ? "Yes"
                                : "No"}
                                </dd>
                            </dl>
                            <dl className="sp-mx7">
                                <dt>Deliver Message Body for XDM Messages:</dt>
                                <dd>
                                {sharedObject.xdrSettiingObj?.sendXDMBody
                                    ? "Yes"
                                    : "No"}
                                </dd>
                            </dl>
                        </div>

                          <dl className="sp-mx7 sp-margin3">
                            <dt>Outbound XDR</dt>
                          </dl>
                          <div className="sub-catg">
                            <dl className="sp-mx7">
                                <dt>XDM Delivery:</dt>
                                <dd>
                                  {sharedObject.orgActionObj?.xdrDoNOTGenerateXDM
                                    ? "Yes"
                                    : "No"}
                                </dd>
                            </dl>
                             <dl className="sp-mx7">
                                 <dt>Out of Network:</dt>
                                <dd>
                                  {sharedObject.orgActionObj?.outOfNetwork
                                    ? "Yes"
                                    : "No"}
                                </dd>
                            </dl>
                             <dl className="sp-mx7">
                                <dt>
                                  Create Direct Automatically:
                                </dt>
                                <dd>
                                  {sharedObject.orgActionObj
                                    ?.inboundCreateDirectAuto
                                    ? "Yes"
                                    : "No"}
                                </dd>
                            </dl>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  {detailsEmail.emailType !== "orgEmails" &&
                  detailsEmail.emailType !== "Organization" ? (
                    <>
                    <section>
                      <div className="field-wrapper label-divider">
                        <h6 className="sp-pad9 spacer-inline" id="msg-fwdHeading">
                          MESSAGE FORWARDING
                        </h6>
                        <div className="v-set2 spacer-inline float-r">
                          <button
                            className="btn btn-link p-0"
                            onClick={(el) => {
                              SetCollapse(!collapse);
                              el.preventDefault();
                            }}
                            type="button"
                            aria-controls="msg-fwd"
                            aria-expanded={!collapse}
                            aria-label={collapse ? "Expand message forwarding" : "Collapse message forwarding"}
                          >
                            <i className={`bi ${ collapse ? "bi-plus" : "bi-dash"}`} aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </section>

                    <section
                        aria-labelledby="msg-fwdHeading"
                        id="msg-fwd"
                        className={`field-wrapper ${
                          collapse ? "collapse" : null
                        }`}
                      >
                        {emlForwarding.length > 0 ? (
                        // Add key prop to mapped elements to avoid React warnings
                        // and ensure proper reconciliation.
                          emlForwarding?.map((el, idx) => {
                            return (
                              <div key={el.forwardingEmailAddress || idx} className="field-wrapper sub-catg">
                                <dl>
                                  <dt>Forwarding To:</dt>
                                  <dd className="word-set">
                                    {el.forwardingEmailAddress}
                                  </dd>
                                </dl>
                                <dl>
                                    <dt>Status:</dt>
                                    <dd>{el.forwardingStatus}</dd>
                                </dl>
                                <dl>
                                    <dt>Type:</dt>
                                    <dd>{el.forwardingContentType}</dd>
                                </dl>
                                <dl>
                                    <dt>Type:</dt>
                                    <span>{el.forwardingContentType}</span>
                                </dl>
                                <dl>
                                    <dt>Start Date:</dt>
                                    <dd>
                                      {new Date(
                                        el.forwardingStartDate
                                      ).toLocaleString("en-US", { hour12: false })}
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>End Date:</dt>
                                    <dd>
                                      {new Date(
                                        el.forwardingEndDate
                                      ).toLocaleString("en-US", { hour12: false })}
                                    </dd>
                                </dl>
                              </div>
                            );
                          })
                        ) : (
                          <div className="field-wrapper sub-catg">
                            There are no forwarding emails currently set up.
                          </div>
                        )}
                      </section>
                    </>
                  ) : (
                    <>
                      <div className="field-wrapper label-divider">
                        <h6 className="sp-pad9 spacer-inline" id="membersAssigned">
                          MEMBERS ASSIGNED
                        </h6>
                        <div className="sp-margin3 spacer-inline float-r">
                          <details data-popover="up">
                            <summary aria-label="Information about organization email sharing">
                              <i className="bi bi-info-circle text-size9" aria-hidden="true"></i>
                            </summary>
                            <div role="note">
                              <div className="icon-sign or-clr" aria-hidden="true">
                                <i className="bi bi-info-circle"></i>
                              </div>
                              <div className="sp-margin4">
                                Organization emails can be used for multiple
                                members if sharing is allowed. They will have
                                full access to the same mailbox to send and
                                receive emails.
                              </div>
                            </div>
                          </details>
                        </div>
                      </div>
                      <div className="spacer-margin8">
                        <label htmlFor="SharingAllowed">Sharing Allowed:</label>
                        <div className="spacer-inline ctr">
                          <input
                            type="checkbox"
                            className="form-control"
                            id="SharingAllowed"
                            aria-describedby="SharingAllowedDesc"
                            checked={answers?.SharingAllowed}
                            value={answers?.SharingAllowed}
                            onChange={(e) => {
                              if (answers?.SharingAllowed) {
                                setMsgModal(
                                  "Unchecking this box will remove all users from this mailbox."
                                );
                              } else {
                                setMsgModal(
                                  "Sharing this organization email will allow all assigned users to send and receive messages from this mailbox."
                                );
                              }
                              setAnswer("SharingAllowed", e.target.checked);
                              $("#ConfirmUnsharingModal").modal("show");
                            }}
                          />
                        </div>
                        <div id="SharingAllowedDesc" className="sr-only">
                          Toggling this will open a confirmation dialog before applying changes.
                        </div>
                      </div>
                      
                      <div className="field-wrapper">
                        <table aria-label="Members assigned to this email">
                          <caption className="sr-only">
                            List of users assigned to this shared mailbox
                          </caption>
                          <thead>
                              <tr>
                                <th scope="col"><span className="sr-only">Status</span></th>
                                <th scope="col">Name</th>
                                <th scope="col"><span className="sr-only">Actions</span></th>
                              </tr>
                          </thead>
                          <tbody>
                              {emlShareObj?.map((el) => {
                                if (el.show) {
                                  return (
                                    <tr>
                                      <td>
                                        <span className="dot-gr" aria-label="Active"></span>
                                      </td>
                                      <td>{el.name}</td>
                                      <td>
                                        <button
                                          onClick={(e) => {
                                            UnAssignEmail(el.id, el.userId);
                                            e.preventDefault();
                                          }}
                                          className="btn btn-link p-0"
                                          aria-label={`Unassign ${el.name} from this email`}
                                        >
                                          <i className="bi bi-x-circle" aria-hidden="true"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                }
                              })}
                          </tbody>
                        </table>
                        {emlShareObj?.length === 0 ? (
                          <div className="sub-catg" role="status">
                            There are no users assigned to this email.
                          </div>
                        ) : null}
                      </div>
                      <div className="field-wrapper">
                        If sharing is not allowed, then only one member can be
                        assigned to use this mailbox.
                      </div>
                    </>
                  )}
                  {/*Email Delivery*/}
                  <div className="field-wrapper label-divider">
                    <h6 className="sp-pad9 spacer-inline" id="emailDeliveryTitle">
                      Email Delivery
                    </h6>
                  </div>
                  <div className="field-wrapper sp-margin4">
                    <div className="spacer-inline w-md6">
                      <label htmlFor="Purpose">Purpose</label>
                      <div>
                        <select
                          className="form-control"
                          name="Purpose"
                          id="Purpose"
                          onChange={(el) =>
                            setAnswer("Purpose", parseInt(el.target.value))
                          }
                          value={answers?.Purpose}
                        >
                          <option value={0}>General</option>
                          <option value={1}>Medical Records XML Only</option>
                          <option value={2}>Medical Records</option>
                          <option value={3}>Administrative</option>
                        </select>
                      </div>
                    </div>
                    <div className="spacer-inline spacer-margin9">
                      <label htmlFor="KeepMdn">Keep MDN</label>
                      <div>
                        <select
                          className="form-control"
                          name="KeepMdn"
                          id="KeepMdn"
                          onChange={(el) =>
                            setAnswer("KeepMdn", parseInt(el.target.value))
                          }
                          value={answers?.KeepMdn}
                        >
                          <option value={1}>Yes</option>
                          <option value={0}>No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <section className="field-wrapper">
                    <label htmlFor="ServiceDescription">
                      Service Description
                    </label>
                    <select
                      className="form-control"
                      id="ServiceDescription"
                      value={answers?.DirectTrustServiceDescriptionCode}
                      onChange={(el) => {
                        setAnswer(
                          "DirectTrustServiceDescriptionCode",
                          el.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      {sharedObject?.getServDesc?.map((el) => (
                        <option key={el.code} value={el.code}>
                          {el.display}
                        </option>
                      ))}
                    </select>
                  </section>
                  {submitFlag && successFlag ? (
                    <div className="alert alert-success" role="alert" aria-live="polite" aria-atomic="true">
                      {msg}
                    </div>
                  ) : null}
                  {submitFlag && !successFlag ? (
                    <div className="alert alert-danger" role="alert" aria-live="polite" aria-atomic="true">
                      {errMsg}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={UpdateEmail}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseEmailDetailModal}
                >
                  Cancel
                </button>
              </div>
            </form>
            {processing && (
              <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="details-loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="details-loader-id">{loadingText}</div>
            </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="ConfirmUnsharingModal"
        data-backdrop="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="ConfirmUnsharingTitle"
        aria-describedby="ConfirmUnsharingDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="ConfirmUnsharingTitle">Confirmation</h3>
              <button
                type="button"
                className="close"
                onClick={(e) => CloseEmailSharingModal()}
                aria-label="Close sharing confirmation"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="alert-warning-o" aria-hidden="true">
                  <i className="bi bi-exclamation-circle"></i>
                </div>
                <div className="message-wrapper sp-pad3" id="ConfirmUnsharingDesc">{msgModal}</div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={(el) => ConfirmUnsharing()}
              >
                Confirm
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={(e) => {
                  CloseEmailSharingModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsOrgEmails;
